import { ReactNode } from 'react';
import { GalleryIndexChangeType } from '@bridebook/web/components/gallery/carousel/gallery-carousel';
import { IViewedSupplierProfileSectionAnalytics } from '@bridebook/web/lib/supplier/actions';

export enum GallerySlideType {
  MainPhoto = 'mainPhotoSlide',
  Photo = 'photoSlide',
  Description = 'descriptionSlide',
  ManagerMessage = 'managerMessageSlide',
  Review = 'reviewSlide',
  RealWedding = 'realWeddingSlide',
  ViewProfile = 'viewProfileSlide',
}

export interface GallerySlide {
  slideType: GallerySlideType;
  duration: number;
  component: ReactNode;
  usesAsyncSupplierExtraData?: boolean;
}

export const GallerySlideChangeTypeToAnalytics: Record<
  GalleryIndexChangeType,
  IViewedSupplierProfileSectionAnalytics['viewedMethod']
> = {
  click: 'clicked',
  automatic: 'automatically',
};
